import _ from 'lodash';
import translations from "../constants/translations";

const consentTranslations = {};

consentTranslations.getConsentAgreement = (language) => {

    var consentLanguage = _.get(translations, `${language}.consent`);
    var consentAgreementText = `<h3>${consentLanguage.title}</h3><p>${consentLanguage.consentParagraph1}</p><p>${consentLanguage.consentParagraph2}</p><p>${consentLanguage.consentParagraph3}</p><p>${consentLanguage.consentParagraph4}</p>`

    return { state: "active", content: consentAgreementText};
}

export default consentTranslations;